import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import config from '@@config';
import { textSearchParams } from '@@containers/Search/unitySearchParams';
import { requireRoles } from '@@router/guards';
import { getContentLocale } from '@@scripts/store/settings/useSettingsStore';

import { collectionListQuery } from './-components/collectionListQuery';
import { Layout } from './-components/Layout';

const requireCollectionRoles = requireRoles(config.navigation.collections.authorize);

export const Route = createFileRoute('/_authenticated/collections')({
    validateSearch: textSearchParams,
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => textSearchParams.parse(search),
    beforeLoad: ({ search }) => {
        requireCollectionRoles();

        const contentLocale = getContentLocale();

        // Built on every load, so the options follow the content language as well as the search
        return {
            allCollectionsQuery: collectionListQuery({ q: search.q }, contentLocale),
            emptyCollectionsQuery: collectionListQuery({ q: search.q, empty: true }, contentLocale),
        };
    },
    loader: ({ context }) => {
        // Both tabs' queries run, for their counts
        context.queryClient.query(context.allCollectionsQuery).catch(doNothing());
        context.queryClient.query(context.emptyCollectionsQuery).catch(doNothing());
    },
    component: Layout,
});
